import { render, staticRenderFns } from "./account.vue?vue&type=template&id=0d413ad4&scoped=true&lang=html&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&id=0d413ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d413ad4",
  null
  
)

component.options.__file = "account.vue"
export default component.exports